import convert from 'pcm-convert';
import { intBufferToWavBlob, flatten2dBuffers } from './modules/audioFunctions';

// const FFT_SIZE = 512;
const BUFFER_SIZE = 2048;
// const SILENCE_TIME = 3.0;
const LOUDNESS_THRESHOLD = 0.05;
const DEBUG = true;

export default class AudioRecorder {
    recordBuffer = [];
    recordBufferMaxes = [];
    recordLength = 0;
    recording = false;
    silenceCallback = null;
    silenceSeconds = 3.0;
    lastBuffer = null;
    sampleRateMultiplier = 1;
    audioContext = null;
    stream = null;
    hasBeenSilent = false;

    constructor(_stream, _audioContext) {
        this.stream = _stream;
        this.audioContext = _audioContext;

        this.id = Math.random() * 10000;
    }

    onSilence(_silenceCallback) {
        this.silenceCallback = _silenceCallback;
    }

    setSilenceSeconds(_silenceSeconds) {
        console.log('setting silence seconds to: ', _silenceSeconds);
        this.silenceSeconds = parseFloat(_silenceSeconds);
    }

    setSampleRateMultiplier(_sampleRateMultiplier) {
        console.log('setting multiplier to ', _sampleRateMultiplier);
        this.sampleRateMultiplier = _sampleRateMultiplier;
    }

    async initAudio() {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            throw new Error('getUserMedia is not supported in this browser');
        }

        console.log('audioContext', this.AudioContext);

        // Create an AudioNode from the stream.
        this.audioInput = this.audioContext.createMediaStreamSource(
            this.stream
        );

        this.inputPoint = this.audioContext.createGain();
        this.audioInput.connect(this.inputPoint);

        const bufferLen = BUFFER_SIZE;
        this.context = this.inputPoint.context;
        this.node = this.context.createScriptProcessor(bufferLen, 2, 2);

        this.inputPoint.connect(this.node);
        this.node.connect(this.context.destination);

        this.node.onaudioprocess = e => {
            this.lastBuffer = e.inputBuffer.getChannelData(0);
            if (!this.recording) return;
            this.addBuffer(e.inputBuffer.getChannelData(0));
        };

        return this.audioContext;
    }

    addBuffer(inputBuffer) {
        // The Float32Array typed array represents an array of
        // 32-bit floating point numbers (corresponding to the C float data type)
        // in the platform byte order.
        const buf = new Float32Array(inputBuffer);
        this.recordBuffer.push(buf);
        this.recordLength += inputBuffer.length;
        this.analyseBuffer(buf);
    }

    reset() {
        this.recordBuffer = [];
        this.recordLength = 0;
        this.recordBufferMaxes = [];
        this.hasBeenSilent = false;
    }

    getRecording() {
        const buf = this.context.createBuffer(
            2,
            this.recordLength,
            this.context.sampleRate * this.sampleRateMultiplier
        );
        let offset = 0;
        for (var i = 0; i < this.recordBuffer.length; i++) {
            buf.copyToChannel(this.recordBuffer[i], 0, offset);
            buf.copyToChannel(this.recordBuffer[i], 1, offset);
            offset += this.recordBuffer[i].length;
        }

        return buf;
    }

    setRecording(recording) {
        this.recording = recording;
        if (recording) {
        }
    }

    continue() {
        let intbuffer = convert(
            flatten2dBuffers(this.recordBuffer),
            'float32',
            'int16'
        );

        let blob = intBufferToWavBlob(
            intbuffer,
            this.context.sampleRate * this.sampleRateMultiplier
        );

        var reader = new window.FileReader();
        reader.readAsBinaryString(blob);
        reader.onloadend = e => {
            var audioData = btoa(e.target.result);
            this.silenceCallback(audioData, this.recordBuffer);
        };
    }

    analyseBuffer(buf) {
        // Add our current max
        const bufMax = Array.from(buf).reduce(
            (acc, sample) => Math.max(acc, Math.abs(sample)),
            0
        );

        this.recordBufferMaxes.push(bufMax);

        if (this.hasBeenSilent) return;

        /// Check our maxes
        const samplesNeeded =
            this.silenceSeconds * this.audioContext.sampleRate;
        const bufsRequired = samplesNeeded / BUFFER_SIZE;

        // console.info('analyse', {
        //     buffers: this.recordBuffer,
        //     maxes: this.recordBufferMaxes,
        //     bufsRequired,
        //     id: this.id,
        // });

        if (this.recordBuffer.length > bufsRequired) {
            const lastMaxes = this.recordBufferMaxes.slice(
                this.recordBufferMaxes.length - bufsRequired,
                this.recordBufferMaxes.length
            );

            const sampleMax = lastMaxes.reduce((acc, n) => Math.max(acc, n), 0);
            if (DEBUG) console.log('sample max: ', sampleMax);
            if (sampleMax < LOUDNESS_THRESHOLD) {
                this.hasBeenSilent = true;
                if (this.silenceCallback) {
                    // console.log('recordbuffer: ', this.recordBuffer);
                    this.continue();
                }
            }
        }
    }
}
